import React from 'react'
import {ParagraphText, Radio} from '@thryvlabs/maverick'

function PaymentTypeValidation({paymentType, setPaymentType}) {
  const handlePaymentTypeChange = ({target: {value}}) => {
    setPaymentType(prevState => ({...prevState, value}))
  }

  return (
    <div className="d-flex flex-column" style={{rowGap: '30px'}}>
      <div>
        <ParagraphText variant="reg" className="text-left">
          {'How would you like to pay your vertical service fees?'}
        </ParagraphText>
        <div className="d-flex gap-3">
          <Radio
            hasLabel
            id="oneTime"
            name="paymentType"
            value="oneTime"
            label="All at once"
            toggled={paymentType === 'oneTime'}
            handleOnChange={handlePaymentTypeChange}
          />
          <Radio
            hasLabel
            id="6Monthly"
            name="paymentType"
            value="6Monthly"
            label="Over 6 invoices"
            toggled={paymentType === '6Monthly'}
            handleOnChange={handlePaymentTypeChange}
          />
        </div>
      </div>
    </div>
  )
}

export {PaymentTypeValidation}
